import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { fadeInRight400ms } from 'src/@core/animations/fade-in-right.animation';
import { fadeInUp400ms } from 'src/@core/animations/fade-in-up.animation';
import { stagger40ms } from 'src/@core/animations/stagger.animation';
import { JobService } from 'src/@core/services/job/job.service';

@Component({
  selector: 'hour4u-admin-assigned-vendors',
  templateUrl: './assigned-vendors.component.html',
  styleUrls: ['./assigned-vendors.component.scss'],
  animations: [
    fadeInUp400ms,
    stagger40ms,
    fadeInRight400ms
  ],
})
export class AssignedVendorsComponent implements OnInit {
  @Input() data: any;
  selectedStatus: string[] = [];
  statusList = ['Requested', 'Accepted', 'Rejected'];
  dataSource: MatTableDataSource<any>;
  allVendorsInProject: any[] = [];
  displayedColumns: string[] = ['name', 'status', 'quotesReceived', 'grantedPO', 'numberOfWorkOrders'];

  constructor(private jobService: JobService) { }

  ngOnInit() {
    if (this.data && this.data.id) {
      this.fetchAssignedVendorsList(this.data.id);
    }
  }

  fetchAssignedVendorsList(jobId) {
    this.jobService.fetchAssignedVendorsOfProject(jobId).subscribe((assignedVendors) => {
      this.allVendorsInProject = assignedVendors;
      this.dataSource = new MatTableDataSource(assignedVendors);
    });
  }

  onFilterChange(): void {
    if (this.selectedStatus.length) {
      const filteredData = this.allVendorsInProject.filter((vendor) =>
        this.selectedStatus.some(status => status.toLowerCase() === vendor.status.toLowerCase())
      );
      this.dataSource.data = filteredData;
    } else {
      this.dataSource.data = this.allVendorsInProject;
    }
  }


  clearStatusSelection(event: Event): void {
    event.stopPropagation();
    this.selectedStatus = [];
    this.dataSource.data = this.allVendorsInProject;
  }

  viewVendor(vendorId): void {
    console.log('View vendor:', vendorId);
  }
}
